import script from "./AbuseReports.vue?vue&type=script&setup=true&lang=js"
export * from "./AbuseReports.vue?vue&type=script&setup=true&lang=js"

import "./AbuseReports.vue?vue&type=style&index=0&id=430ae0f4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-430ae0f4"]])

export default __exports__